import { EntityDashboard as Component } from './component';
import Connector from './connector';
import { ConnectorProps } from './EntityDashboard.proptype';

export interface EntityDashboardProps extends Omit<ConnectorProps, 'component'> {}

export const EntityDashboard = (props: EntityDashboardProps) => <Connector {...props} component={Component} />;
